module.exports = __webpack_public_path__ + "static/Victory concert-page-001-2c0f56af8d3a4152b4468479f6678d3a.jpg";